<div class="card">
    <app-calculate-echeances class="substep"></app-calculate-echeances>
</div>

